import { createReducer, on } from '@ngrx/store';
import { BankWithBranchDto } from '../../generated/auth/models/Sasfin/Wealth/Online/Infrastructure/Models/bank-with-branch-dto';
import {
  loadBankWithBranchesFailure,
  loadBankWithBranchesSuccess,
  toggleBankWithBranchesLoading,
} from './bank-with-branches.actions';
import { IBankWithBranchesState, initialUIState } from './bank-with-branches.state';

export const bankWithBranchesReducer = createReducer(
  initialUIState,
  on(loadBankWithBranchesSuccess, (state, { bankWithBranches }) => ({
    ...state,
    list: bankWithBranches,
  })),
  on(loadBankWithBranchesFailure, (state) => ({
    ...state,
    list: [] as BankWithBranchDto[],
  })),
  on(toggleBankWithBranchesLoading, (state, { loading }) => ({
    ...state,
    loading,
  }))
);
